<form
    [formGroup]="form"
    class="input-grid-gaps grid-6col mt-1 person-notes-dialog"
    #content
>
    <app-input-wysiwyg
        id="note"
        class="fr-6"
        editorKey="PersonNotesDialogNote"
        [form]="form">
    </app-input-wysiwyg>
</form>
